// ApexCharts plugin configuration
import VueApexCharts from 'vue3-apexcharts'

export default {
  install: app => {
    app.use(VueApexCharts)
  }
}
